<template>
  <div class="right-rail" v-if="fields.technologies && fields.technologies.length > 0">
    <div class="related-resources" v-if="fields.technologies && fields.technologies.length > 0">
      <h3 class="related-resources__header">Related Resources</h3>
      <a href="/cis-benchmarks/">
        <img
          src="../../../assets/images/CIS_Benchmarks_RGB_TM.png"
          alt="CIS Benchmark"
          class="related-resources__logo"
        />
      </a>
      <div v-for="(item, index) in fields.technologies" :key="`technologies-${index}`">
        <a :href="`/benchmark/${item.fields.slug.value}`" class="c-cta--secondary">
          <span>{{ item.fields.name.value }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CIS-Related-Resources',
  props: {
    fields: {
      type: Object
    }
  }
};
</script>

<style lang="scss">
.c-site__main {
  .right-rail {
    margin-left: 0;

    @include tablet-down {
      padding-top: 2rem;
      padding-left: 1rem;
    }

    .related-resources {
      margin-bottom: 2em;

      &__header {
        font-size: 2rem;
        line-height: 2rem;
        margin-bottom: 3rem;

        @include font-styles('Arial', 2rem, 200, normal, normal, 0, $dark-blue);

        @include tablet-up {
          font-size: 3.6rem;
          line-height: 3.6rem;
        }
      }

      &__logo {
        max-width: 70%;
        margin-bottom: 2rem;

        @include tablet-up {
          max-width: 35%;
        }

        @include desktop-up {
          max-width: 70%;
        }
      }

      a {
        &.c-cta- {
          &-primary,
          &-secondary,
          &-tertiary {
            width: 100%;
          }
          &-secondary {
            text-transform: none;
          }
        }
      }
    }
  }
}
</style>
